
import { Component, Vue, Prop } from "vue-property-decorator";
import ProjectsItem from "./ProjectsItem.vue";
@Component({
  components: {
    ProjectsItem
  }
})
export default class Projects extends Vue {
  @Prop({ required: true }) private list!: any;
}
